<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
             <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/">Início</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Meus certificados / {{ client.name }}</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow">
                            <div class="card-header mt-1">
                                <span>Cliente: <strong>{{ client.name }}</strong></span>
                            </div>
                            <div class="card-body" :class="files.length <=0? 'card-body-no-spaccing':''">
                                <div class="row">
                                    <div class="col-sm-12 col-xs-12 col-lg-12">
                                        <div class="table-responsive">
                                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Descrição</th>
                                                        <th class="text-center">Vencimento</th>
                                                        <th class="text-center">Criado em</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="!filter_send_by_client">
                                                    <tr v-for="(file, index) in files" :key="index.id">
                                                        <td>{{ index + 1 }}</td>
                                                        <td>{{ file.description }}</td>
                                                        <td class="text-center">{{
                                                            file.overdue_formatted?file.overdue_formatted:'-' }}</td>
                                                        <td class="text-center">{{ file.created_at }} </td>
                                                        <td>
                                                            <div class="dropdown">
                                                                <button class="btn btn-primary dropdown-toggle"
                                                                    type="button" id="dropdownMenuButton"
                                                                    data-toggle="dropdown" aria-haspopup="true"
                                                                    aria-expanded="false">
                                                                    Ações
                                                                </button>
                                                                <div class="dropdown-menu animated--fade-in"
                                                                    aria-labelledby="dropdownMenuButton">
                                                                    <a class="dropdown-item" href="#"
                                                                        @click="downloadFile(file.id)">Baixar
                                                                        arquivo</a>
                                                                    <a class="dropdown-item" href="#"
                                                                        @click="showModalCreateCertificate(file.password)">Visualizar
                                                                        senha</a>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr v-show="files.length <= 0 && files.length <= 0">
                                                        <td colspan="6" class="text-center">Nenhum registro encontrado
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal -->

    <div id="modalDisplayCertificate" class="modal" :style="{ display: modalDisplayCertificate }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="createNewFile">
                    <div class="modal-content border-left-primary">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newFileLabel">Senha certificado</h5>
                            <button type="button" class="close" @click="closeModalPassword()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <label for="">Senha</label>
                                    <input disabled type="text" class="form-control" v-model="password_modal">
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" @click="closeModalPassword()">Cancelar</button>

                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
export default {
    components: { Loading },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            client: {},
            directories: {},
            files: {},
            modalDisplayCertificate: 'none',
            progressBarFile: 0,
            client_id: '',
            enable_error_list: false,
            errors: [],
            password_modal: '',
            file: {
                description: '',
                password: '',
                archive: null,
                client_id: '',
                size: '',
                overdue: '',
                certificate_id: ''
            }
        }
    },

    computed: {
        isDisabledFile: function () {
            return this.file.description != '' && this.file.archive != null;
        },
        isDisabledFileUpdate: function () {
            return this.file.description != '';
        }
    },
    mounted() {
        this.isLoading = false;
        const id =  localStorage.getItem('client_id');
        this.client_id = id;
        this.getCertificateClient();
    },

    methods: {
        onCancel() { },
        getCertificateClient() {
            this.isLoading = true;
            api.get('/client-user/' + this.client_id + '/certificates')
                .then((response) => {
                    this.isLoading = false;
                    this.client = response.data.client;
                    this.files = response.data.certificates;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },

        generateRandom() {
            return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
                (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
            );
        },

        async downloadFile(file_id) {
            this.isLoading = true;
            api.get('/client-user/' + file_id + '/downloadCertificate', { responseType: 'blob' })
                .then((response) => {
                    const contentType = response.headers.get('Content-Type');
                    this.isLoading = false;
                    const blob = new Blob([response.data], { type: contentType })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob);
                    link.download = 'download_' + this.generateRandom();
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },
         showModalCreateCertificate(password) {
            this.password_modal = password;
            this.modalDisplayCertificate = 'block';
        },
        closeModalPassword() {
            this.modalDisplayCertificate = 'none';
        },
    }
}
</script>

<style>
.pointer {
    cursor: pointer;
}

.modal {
    position: fixed;
    z-index: 1999;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
    background-color: #f5f5f5;
    margin: 3% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 50%;
}

.modal-header {
    color: #000;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}
</style>